<template>
  <v-main>
    <EditDialog ref="dialog" @reload="$refs.report.reload()" />
    <GenericReport
      ref="report"
      orientation="horizontal"
      hide-header
      class="clean-list"
      :reportSpec="reportSpec"
      :adapterSpec="adapterSpec"
      :fetcher="fetchData"
      @rowClicked="selectRow"
    >
      <template v-slot:topbar-actions="{ checkDownload }">
        <v-spacer />
        <v-btn color="primary" @click="newRow">
          Novo Estoque...
        </v-btn>
        <v-btn icon @click="checkDownload">
          <v-icon>$csv</v-icon>
        </v-btn>
      </template>
    </GenericReport>
  </v-main>
</template>

<script>
import { Depot } from '@/models'
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import { matchAnyLike } from 'oderon-commons/src/utils'
import EditDialog from './EditDialog.vue'

export default {
  pageTitle: 'Estoques',
  components: {
    GenericReport,
    EditDialog
  },
  data() {
    return {
      reportSpec: {
        title: 'Estoques',
        filters: [
          {
            type: 'Text',
            prefix: 'keywords',
            icon: 'mdi-magnify',
            size: 'md',
            debounceMs: 250
          },
          {
            type: 'Switch',
            prefix: 'showInactive',
            label: 'Mostrar inativos'
          }
        ]
      },

      adapterSpec: {
        columns: [
          { t: 'ID|', w: 100, d: 'id', color: '#cccccc' },
          { t: 'Nome', d: 'name' }
        ]
      }
    }
  },
  methods: {
    async fetchData({ showInactive, keywords }) {
      let rows = await Depot.findAll()
      rows = rows.filter((x) => {
        if (x.deletedAt != null && !showInactive) return false
        return matchAnyLike(keywords, x.name)
      })

      return rows
    },

    selectRow({ row, isMiddle }) {
      if (isMiddle) window.open(`/#/setup/depots/${row.id}`, '_blank')
      // else this.$router.push(`/setup/depots/${row.id}`)
      else this.$refs.dialog.open(row.id)
    },

    async newRow() {
      let label = 'Digite o nome do novo estoque'
      let name = await this.$prompt({ label })
      if (name != null) {
        let row = await this.$loading(async () => {
          return Depot.save({ name })
        })
        this.$refs.report.reload()
        if (row != null) this.selectRow({ row })
      }
    }
  }
}
</script>

<style></style>
